interface HighlightTextProps {
  className?: string;
  searchQuery: string;
  text: string;
}

export function HighlightText({ className = '', searchQuery, text }: HighlightTextProps) {
  if (!searchQuery.trim()) {
    return <span className={className}>{text}</span>;
  }

  const parts = text.split(
    new RegExp(`(${searchQuery.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`)})`, 'gi'),
  );

  return (
    <span className={className}>
      {parts.map((part, index) => {
        const isMatch = part.toLowerCase() === searchQuery.toLowerCase();
        return isMatch ? (
          <mark className="text-foreground bg-[var(--Primary-Blue-200,#B3C3F6)] px-0.5" key={index}>
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        );
      })}
    </span>
  );
}
